import {
  takeLatest,
  call,
  put,
  all,
  takeEvery,
  select
} from "redux-saga/effects";
import * as actions from "./hospitalActions";
import * as types from "./hospitalTypes";
import * as api from "./hospitalAPIs";
import AppId from "~/utils/partner";
import { client } from "~/utils/medproSDK";
import { get } from "lodash";
const loadedHospitalListByFeatureId = {};

function* requestHospitalList() {
  try {
    // yield put(actions.loadingHospitalList());
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    let response;
    if (AppId === "medpro" || AppId === "momo") {
      response = yield client.getHospitalListByAppId(
        { appid: AppId },
        { platform }
      );
    } else {
      response = yield call(api.requestHospitalList);
    }
    const { data } = response;
    if (data.error_code) throw Error("Loading hospital list fail!");
    yield put(actions.requestHospitalListSuccess(data));
    if (AppId !== "medpro") {
      const index = data.findIndex(item => item.partnerId === AppId);
      yield put(actions.selectHospital(data[index].partnerId));
    }
  } catch (error) {
    yield put(actions.requestHospitalListFail(error));
  }
}

function* hospitalListWatcher() {
  yield takeLatest(types.REQUEST_HOSPITAL_LIST, requestHospitalList);
}

function* requestHospitalListByFeatureId({ id }) {
  if (!loadedHospitalListByFeatureId[id]) {
    try {
      yield put(actions.loadingHospitalListByFeatureId(id));
      const response = yield call(api.requestHospitalListByFeatureId, id);
      const { data } = response;
      if (data.error_code)
        throw Error(`Loading hospital list by feature id ${id} fail!`);
      yield put(actions.requestHospitalListByFeatureIdSuccess(id, data));
      loadedHospitalListByFeatureId[id] = true;
    } catch (error) {
      yield put(actions.requestHospitalListByFeatureIdFail(id, error));
    }
  }
}

function* requestFeatureByHospitalId({ id }) {
  try {
    // yield put(actions.loadingHospitalListByFeatureId(id));
    const response = yield call(api.requestFeatureByHospitalId, id);
    const { data } = response;
    if (data.error_code)
      throw Error(`Loading feature list by hosital id ${id} fail!`);
    yield put(actions.requestFeatureByHospitalIdSuccess(id, data));
    loadedHospitalListByFeatureId[id] = true;
  } catch (error) {
    yield put(actions.requestFeatureByHospitalIdFail(id, error));
  }
}

function* hospitalListByFeatureIdWatcher() {
  yield takeEvery(
    types.REQUEST_HOSPITAL_LIST_BY_FEATURE_ID,
    requestHospitalListByFeatureId
  );
  yield takeEvery(
    types.REQUEST_FEATURE_LIST_BY_HOSPITAL_ID,
    requestFeatureByHospitalId
  );
}

export default function* root() {
  yield all([call(hospitalListWatcher), call(hospitalListByFeatureIdWatcher)]);
}
